/* eslint-disable import/prefer-default-export */
/* eslint-disable no-bitwise */

// Numerical borrower entities (bit values)
export enum BorrowerEntity {
  BorrowerNone = 0, // 0
  Borrower1 = 1 << 0, // 1
  Borrower2 = 1 << 1, // 2
  Borrower3 = 1 << 2, // 4
  Borrower4 = 1 << 3, // 8
}
